import gql from 'graphql-tag'

export const UPDATE_HERO_CONFIG = gql`
  mutation UpdateHeroConfig($id: Int!, $data: HeroConfigUpdateInput!) {
    updateHeroConfig(id: $id, data: $data) {
      id
      heroType
      locationCount
      radius
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/HeroConfig.js